module.exports = __webpack_public_path__ + "img/hearts-content.fa9cd2d0.svg";